module.exports = __webpack_public_path__ + "img/nevill_b1.2210cc27.jpg";